import { ToastOptions } from "@/components/wrappers/Spectrum/SpectrumTypes.ts"
import { ToastQueue } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export const Endpoints = {
  login: "/api/auth/login",
}

export const baseUrl = "https://hp.local:8081"
export type ErrorResponse = {
  errorId: string
  message: string
  requestData: string
}

export function toastOptions(errorResponse: ErrorResponse): ToastOptions {
  return {
    timeout: 10000,
    id: errorResponse.errorId,
  }
}

export async function appFetch<R, I>(
  endpoint: keyof typeof Endpoints,
  method: keyof typeof HTTP,
  body: I
): Promise<R | ErrorResponse> {
  const url = baseUrl + Endpoints[endpoint]
  if (method === HTTP.POST && (body === undefined || body === null)) {
    console.error("Post request needs body")
  }
  if (method === HTTP.GET && body !== undefined) {
    console.error("Get request shouldn't have body")
  }
  try {
    const response = await fetch(url, {
      method: method,
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(body),
    }).then((response) => {
      return response
    })

    if (response.ok) {
      return (await response.json()) as R
    } else {
      const errorResponse = (await response.json()) as ErrorResponse
      ToastQueue.negative(
        `Code : ${response.status.toString()}, Message: ${errorResponse.message}`,
        toastOptions(errorResponse)
      )
      return errorResponse
    }
  } catch (error: unknown) {
    console.log(error)
    const internetConnection = window.navigator.onLine
    const errorResponse: ErrorResponse = {
      errorId: "",
      requestData: "",
      message: internetConnection
        ? "Backend Server Offline. Try again later."
        : "Browser offline. Check your internet connection.",
    }
    ToastQueue.negative(errorResponse.message, toastOptions(errorResponse))
    return errorResponse
  }
}

export const HTTP = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
}
